export default __webpack_public_path__ + "static/media/birds.5bf93df6.webp";